import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable()
export class DateService {
  constructor() {}

  public validInterval(initDate, endDate) {
    return moment(initDate).isBefore(endDate);
  }

  public getDateDiffInDays(initDate, endDate) {
    return moment(endDate).diff(initDate, 'days');
  }

  public formatDate(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  public utcToLocale(date) {
    return moment(date).locale();
  }

  public localToUtc(date) {
    return moment(date).utc();
  }

  public intervalGreaterThanOneYear(startDate, endDate) {
    if (moment(startDate).isLeapYear() || moment(endDate).isLeapYear()) {
      return this.getDateDiffInDays(startDate, endDate) > 366;
    }

    return this.getDateDiffInDays(startDate, endDate) > 365;
  }
}
